import { render, staticRenderFns } from "./WGlist.vue?vue&type=template&id=4100330a&"
import script from "./WGlist.vue?vue&type=script&lang=js&"
export * from "./WGlist.vue?vue&type=script&lang=js&"
import style0 from "./WGlist.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports